import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_BASE_URL

const axiosInstance = axios.create({
  baseURL: API_URL,
})

axiosInstance.interceptors.request.use((config) => {
  const method = config.method?.toLowerCase()

  // Append a timestamp to every GET request so the browser never serves a
  // stale cached response via If-None-Match / 304 Not Modified.
  // When the browser has the ETag but its cached body has been evicted
  // (memory cache cleared, tab backgrounded, etc.) it sends If-None-Match
  // and gets a 304 back — but with no body to serve, axios receives an empty
  // response, orderData stays {}, and "Order Journal Unavailable" is shown.
  // A unique URL per request prevents all of that with no CORS side-effects.
  if (method === 'get') {
    config.params = { ...config.params, _t: Date.now() }
  }

  // Only attach Content-Type for requests that carry a body.
  // Setting it on GET requests makes them non-simple CORS requests and forces
  // an unnecessary OPTIONS preflight on every call.
  if (['post', 'put', 'patch'].includes(method)) {
    config.headers['Content-Type'] = 'application/json'
  }

  return config
})

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error?.message || 'Something went wrong!')
)

export default axiosInstance;
